<div class="note-container">
  <!-- Header z przyciskiem powrotu -->
  <div class="header-section">
    <div class="header-top">
      <button mat-mini-fab class="back-button" routerLink="../../">
        <img style="width:25px;" src="/assets/img/back.png" alt="back">
      </button>
      <h1 class="note-title" *ngIf="!isEditing; else editTitleMode">{{ note.title }}</h1>
      <ng-template #editTitleMode>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Edytuj tytuł</mat-label>
          <input matInput [(ngModel)]="note.title">
        </mat-form-field>
      </ng-template>
    </div>
    <p class="note-type-badge">{{ note.note_type }}</p>
  </div>

  <!-- Główna zawartość notatki -->
  <div class="content-grid">
    <!-- Lewy panel - Treść notatki -->
    <div class="main-content">
      <mat-card class="note-card">
        <mat-card-header>
          <mat-card-title>Zawartość notatki</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="note-text" *ngIf="!isEditing; else editMode">
            {{ note.note }}
          </div>
          <ng-template #editMode>
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Edytuj notatkę</mat-label>
              <textarea matInput [(ngModel)]="note.note" rows="10"></textarea>
            </mat-form-field>
          </ng-template>

          <!-- Załączniki -->
          <div class="attachments-section" *ngIf="note.attachment">
            <h3>Załączniki</h3>
            <div class="attachment-item">
              <button mat-mini-fab class="close-btn" color="warn" *ngIf="isEditing" (click)="onDeleteAttachment()"><mat-icon>delete</mat-icon></button>
              <mat-icon>attach_file</mat-icon>
              <!-- <span>{{ note.attachment }}</span> -->
              <!-- <img [src]="note.attachment_url" *ngIf="!note.attachment_url?.endsWith('.txt')" alt="Zdjęcie"/> -->
              <!-- <object [src]="attachmentUrl" width="100%" height="500"></object> -->
              <object [data]="attachmentUrl" type="text/plain" width="100%"></object>
                
              
            </div>
          </div>
          <div *ngIf="!note.attachment && isEditing">
            <h3>Załączniki</h3>
            <input type="file"
            #fileInput 
            (change)="onFileSelected($event)" 
            accept="image/*,application/pdf" 
            hidden
            multiple>

            <button mat-button type="button" (click)="fileInput.click()">
              Dodaj załącznik
            </button>
            <div *ngFor="let file of selectedFiles">
              <span>{{ file.name }}</span> <button mat-icon-button color="warn" type="button" (click)="onDeleteFile(file)" aria-label="Usuń plik">
                <mat-icon>close</mat-icon>
              </button> 
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Prawy panel - Informacje dodatkowe -->
    <div class="sidebar">
      <!-- Informacje o autorze -->
      <mat-card class="info-card">
        <mat-card-header>
          <mat-card-title>Informacje o notatce</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="info-item">
            <span class="label">Utworzona:</span>
            <span class="value">{{ note.created_at | date:'short' }}</span>
          </div>

          <div class="info-item" *ngIf="note.creator">
            <span class="label">Autor:</span>
            <span class="value">{{ note.creator.name }} {{ note.creator.surname }}</span>
          </div>

          <div class="info-item" *ngIf="note.last_edited_at">
            <span class="label">Ostatnia edycja:</span>
            <span class="value">{{ note.last_edited_at | date:'short' }}</span>
          </div>

          <div class="info-item" *ngIf="note.editor">
            <span class="label">Edytował:</span>
            <span class="value">{{ note.editor.name }} {{ note.editor.surname }}</span>
          </div>

          <div class="info-item" *ngIf="note.updated_at">
            <span class="label">Zaktualizowana:</span>
            <span class="value">{{ note.updated_at | date:'short' }}</span>
          </div>

          <div class="info-item">
            <span class="label">Typ notatki:</span>
            <span class="value-badge">{{ note.note_type }}</span>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Informacje o usunięciu (jeśli dotyczy) -->
      <mat-card class="info-card" *ngIf="note.deleted_at">
        <mat-card-header>
          <mat-card-title>Status usunięcia</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="info-item">
            <span class="label">Usunięta:</span>
            <span class="value">{{ note.deleted_at | date:'short' }}</span>
          </div>

          <div class="info-item" *ngIf="note.delete_requested_at">
            <span class="label">Żądanie usunięcia:</span>
            <span class="value">{{ note.delete_requested_at | date:'short' }}</span>
          </div>

          <div class="info-item" *ngIf="note.delete_reason">
            <span class="label">Powód usunięcia:</span>
            <span class="value">{{ note.delete_reason }}</span>
          </div>

          <div class="info-item" *ngIf="note.delete_approver">
            <span class="label">Zatwierdził usunięcie:</span>
            <span class="value">{{ note.delete_approver.name }} {{ note.delete_approver.surname }}</span>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Akcje -->
      <div class="actions-section">
        <button mat-raised-button class="action-button" *ngIf="!isEditing; else editActions" (click)="isEditing = true">
          <mat-icon>edit</mat-icon>
          Edytuj notatke
        </button>
        <ng-template #editActions>
          <button mat-raised-button class="action-button" (click)="onSaveNote()">
            <mat-icon>save</mat-icon>
            Zapisz zmiany
          </button>
          <button mat-raised-button class="action-button" (click)="onCancelEdit()">
            <mat-icon>cancel</mat-icon>
            Anuluj
          </button>
        </ng-template>
        <button mat-raised-button class="action-button delete-button" (click)="onDeleteNote()" [disabled]="isDeleting">
          <mat-icon>delete</mat-icon>
          Usuń notatke
        </button>
      </div>
    </div>
  </div>
</div>
